// Confirmation dialog shown before deleting a page from a blog post.
// Extracted from BlogsPage.js.

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from '@mui/material';
import { Delete } from '@mui/icons-material';

/**
 * @param {object} props
 * @param {boolean} props.open
 * @param {number|null} props.pageToDelete - 0-based index of the page to delete; shown as 1-based in the prompt.
 * @param {() => void} props.onCancel
 * @param {() => void} props.onConfirm
 */
const DeletePageDialog = ({ open, pageToDelete, onCancel, onConfirm }) => (
  <Dialog
    open={open}
    onClose={onCancel}
    maxWidth="sm"
    fullWidth
  >
    <DialogTitle>
      Delete Page
    </DialogTitle>
    <DialogContent>
      <Typography>
        Are you sure you want to delete Page {pageToDelete !== null ? pageToDelete + 1 : ''}?
        This action cannot be undone and all content on this page will be lost.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        color="error"
        startIcon={<Delete />}
      >
        Delete Page
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeletePageDialog;
